import { get } from '_services/requests'

export const getPaymentAdvance = (key, serviceOrderId) =>
  get(['serviceorders', serviceOrderId, 'get-anticipation-payments'], { key })
